module.exports = __webpack_public_path__ + "static/media/Romplakat.95466af7.jpg";